module.exports = __webpack_public_path__ + "static/media/noiseBlob.d1f33156.mp4";